<template src="./html/Foot.html"></template>

<script>
export default {
	props: ['user', 'isAuth'],
	data() {
		return {
			date: moment().format('Y')
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/partials/views/Foot.vue